import {
    useAppSidePanelContextProvider
} from "../../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import dayjs, { Dayjs } from 'dayjs';
import { ProfileType } from "../../../options-table/types/ProfileType";
import { dateTimeConversionService } from "../../../../shared/services/DateTimeConversionService";
import { ApplicationDateTimePicker } from "../../../../shared/components/date-time-picker/ApplicationDateTimePicker";
import { CustomDateTimePickerTooltipContent } from "./CustomDateTimePickerTooltipContent";

export function CustomDateTimePicker() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
        selectedPortfolioDates,
    } = useAppSidePanelContextProvider();

    async function handleSelection(selectedDate: Dayjs | null) {
        if (selectedDate == null ||
            selectedPortfolio === undefined ||
            selectedPortfolio === null ||
            selectedPortfolio.portfolioSettings === null
        ) {
            return;
        }
        
        selectedPortfolio.portfolioSettings.selectedCustomDate = dateTimeConversionService.toUtcDate(selectedDate);
        updateSelectedPortfolio();
        saveSelectedPortfolio();
    }

    const selectedProfileTypes = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.selectedProfileTypes
        : [];
    
    const isTripleCustomBalanceEnabled = selectedPortfolio!.portfolioSettings!.isTripleCustomBalanceEnabled;
    
    return (
        <ApplicationDateTimePicker
            value={selectedPortfolio !== undefined && selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
                ? dayjs(selectedPortfolio.portfolioSettings.selectedCustomDate)
                : dayjs()}
            onChange={handleSelection}
            width={195}
            slotProps={{
                textField: {
                    InputProps: {
                        sx: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            height: '24px',
                            margin: '0px 0px 0px 0px',
                            padding: '6px 0px 0px 0px',
                        }
                    }
                },
            }}
            sx={{
                '.MuiFormLabel-root': {
                    fontWeight: 'bold'
                },
                '& .MuiSvgIcon-root': {
                    fontSize: '24px',
                    marginTop: '-6px',
                    marginRight: '2px',
                },
            }}
            tooltipTitle={
                <CustomDateTimePickerTooltipContent
                    selectedPortfolioDates={selectedPortfolioDates!}
                    isTripleCustomBalanceEnabled={isTripleCustomBalanceEnabled}
                />
            }
            tooltipPlacement='left-start'
            tooltipMaxWidth='500px'
            disabled={selectedProfileTypes.indexOf(ProfileType.Custom) === -1}
        />
    );
}
